import type { UseQueryResult } from '@tanstack/react-query'
import { type AppError, useGetProfilePicture } from '@dhl/receiver-profile-api'

/**
 * In the future we can invalidate this query
 */
export const getGetProfilePictureUrlQueryKey = () => [`/profile/picture/url`] as const

export const useGetProfilePictureUrl = (isEnabled: boolean): UseQueryResult<string | undefined, AppError | null> =>
  useGetProfilePicture({
    query: {
      enabled: isEnabled,
      retry: false,
      staleTime: Infinity,

      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,

      queryKey: getGetProfilePictureUrlQueryKey(),
      select: (blob) => {
        try {
          return URL.createObjectURL(blob)
        } catch {
          return undefined
        }
      },
    },
  })
